module.exports = __webpack_public_path__ + "img/42.9c73d0b8.gif";